<form [formGroup]="formGroup">
  @for (element of elements; track element.name) {
    @if (element.type === "section") {
      <div class="section">
        <b class="section-title">{{ element.title }}</b>
      </div>
    }
    @if (element.type === "text") {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                type="button"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <input
              type="text"
              class="add-patient-input"
              [formControlName]="element.name"
            />
          </div>
        </div>
      </div>
    }
  }
</form>
